import { render, staticRenderFns } from "./PolygonControls.vue?vue&type=template&id=c130ab18&scoped=true"
import script from "./PolygonControls.vue?vue&type=script&lang=js"
export * from "./PolygonControls.vue?vue&type=script&lang=js"
import style0 from "./PolygonControls.vue?vue&type=style&index=0&id=c130ab18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c130ab18",
  null
  
)

export default component.exports